import * as Sentry from '@sentry/vue'
import {
  LocalStorageNames,
  SessionStorageNames,
  useLocalStorage,
  useSessionStorage
} from '@/6_shared/lib'
import { type User, type UserDTO } from '../model'

export const userAuthToken = {
  get(): string | null {
    return useLocalStorage().get(LocalStorageNames.authToken)
  },
  set(authToken: string) {
    useLocalStorage().set(LocalStorageNames.authToken, authToken)
  },
  clear() {
    useLocalStorage().remove(LocalStorageNames.authToken)
  }
}

export const userId = {
  get(): User['userId'] | null {
    return useSessionStorage().get(SessionStorageNames.userId) as string | null
  },
  set(userId: User['userId']) {
    Sentry.setTag('userId', userId)
    useSessionStorage().set(SessionStorageNames.userId, userId)
  }
}

export const transformSex = (sex: any) => {
  const availableValues = ['0', '1', 0, 1]

  if (availableValues.includes(sex)) {
    return Number(sex)
  }

  return undefined
}

export const transformBirthDate = (
  birthDate: UserDTO['birthYear'] | string
): number | undefined => {
  try {
    const isNotPrimitive = typeof birthDate !== 'string' && typeof birthDate !== 'number'
    if (isNotPrimitive) return undefined

    const value =
      String(birthDate).length < 4
        ? new Date().getFullYear() - Number(birthDate)
        : Number(birthDate)

    return isNaN(value) ? undefined : value
  } catch {
    return undefined
  }
}
